import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

export async function evaluationLaboratoryList(
  accountId: string,
  query?: { [key: string]: any },
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${accountId}/evaluation/laboratory/list${queryString}`,
  );
}

export async function evaluationLaboratoryShow(
  account_id: string,
  item_id: string,
) {
  return await clientAxios.get(
    `account/${account_id}/evaluation/laboratory/${item_id}/show`,
  );
}

export async function evaluationLaboratoryCreate(
  account_id: string,
  payload: {
    evaluation_id: string;
    laboratory_id: string;
  },
) {
  return await clientAxios.post(
    `account/${account_id}/evaluation/laboratory/create`,
    payload,
  );
}

export async function evaluationLaboratoryDelete(
  account_id: string,
  item_id: string,
) {
  return await clientAxios.del(
    `account/${account_id}/evaluation/laboratory/${item_id}/delete`,
  );
}
